import React from 'react';
import { Link } from 'react-router-dom';
import { useConsent } from '../components/CookieBanner';

export default function ConfidentialitePage() {
  const { consent, reset } = useConsent();
  const [done, setDone] = React.useState(false);

  const S = ({ title, children }) => (
    <section style={{ marginBottom:36, paddingBottom:32, borderBottom:'1px solid rgba(140,106,90,.12)' }}>
      <h2 style={{ fontSize:'clamp(16px,2.5vw,20px)', fontWeight:700, marginBottom:14 }}>{title}</h2>
      <div style={{ fontSize:15, color:'#3A2810', lineHeight:1.75 }}>{children}</div>
    </section>
  );

  return (
    <div style={{ paddingTop:'var(--nav-h, 64px)', minHeight:'100vh', background:'var(--radar-cream)' }}>
      <div style={{ maxWidth:800, margin:'0 auto', padding:'clamp(32px,6vw,64px) var(--px, clamp(16px,5vw,40px))' }}>
        <p className="section-label" style={{ marginBottom:12 }}>RGPD · UE 2016/679</p>
        <h1 style={{ fontSize:'clamp(28px,5vw,44px)', fontWeight:700, letterSpacing:'-.02em', marginBottom:16 }}>
          Politique de confidentialité
        </h1>
        <p style={{ fontSize:15, color:'#5A4A3C', lineHeight:1.7, marginBottom:40 }}>
          RADAR s'engage à protéger vos données personnelles conformément au <strong>Règlement Général sur la Protection des Données (RGPD — UE 2016/679)</strong> et à la loi Informatique et Libertés. Cette page explique quelles données nous collectons, pourquoi, et comment exercer vos droits.
        </p>

        <S title="1. Responsable du traitement">
          <p><strong>RÉSAM</strong> — ..............</p>
          <p>Email DPO : <a href="mailto:dpo@radar-course.fr" style={{ color:'var(--radar-deep)' }}>dpo@radar-course.fr</a></p>
          <p>Adresse : [À compléter]</p>
        </S>

        <S title="2. Données collectées et finalités">
          <p style={{ marginBottom:12 }}>Nous collectons uniquement les données strictement nécessaires :</p>
          <div style={{ overflowX:'auto', borderRadius:8, border:'1px solid rgba(140,106,90,.15)' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:13, minWidth:480 }}>
              <thead>
                <tr style={{ background:'var(--radar-light)' }}>
                  {['Donnée','Finalité','Base légale','Conservation'].map(h => (
                    <th key={h} style={{ padding:'10px 12px', textAlign:'left', fontFamily:'var(--font-mono)', fontSize:10, letterSpacing:'.06em', textTransform:'uppercase', color:'var(--radar-mid)', fontWeight:700 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {[
                  ['Nom, email, mot de passe','Compte organisateur','Contrat','Durée compte + 3 ans'],
                  ['Email inscription équipe','Gestion des inscriptions','Contrat','1 an après la course'],
                  ['Nom équipe, membres','Classement et résultats','Intérêt légitime','3 ans'],
                  ['Photos / vidéos','Galerie territoire','Consentement','Jusqu\'à suppression'],
                  ['Adresse IP','Sécurité, logs accès','Intérêt légitime','90 jours'],
                  ['Cookie session (JWT)','Authentification','Nécessité contractuelle','7 jours'],
                  ['Cookies analytiques','Amélioration du site (anonyme)','Consentement','13 mois max'],
                ].map(([d,f,b,r]) => (
                  <tr key={d} style={{ borderTop:'1px solid rgba(140,106,90,.08)' }}>
                    <td style={{ padding:'9px 12px', fontSize:13, fontWeight:500 }}>{d}</td>
                    <td style={{ padding:'9px 12px', fontSize:13, color:'#5A4A3C' }}>{f}</td>
                    <td style={{ padding:'9px 12px', fontSize:12, color:'var(--radar-mid)', fontFamily:'var(--font-mono)' }}>{b}</td>
                    <td style={{ padding:'9px 12px', fontSize:12, color:'var(--radar-mid)', fontFamily:'var(--font-mono)', whiteSpace:'nowrap' }}>{r}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </S>

        <S title="3. Cookies">
          <p style={{ marginBottom:14 }}>Deux catégories de cookies sont utilisées :</p>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {[
              { name:'Cookies essentiels', badge:'Toujours actifs', bc:'#2E7D32', desc:'JWT d\'authentification, préférences de session. Sans ces cookies, le site ne peut pas fonctionner.' },
              { name:'Cookies analytiques', badge:'Avec consentement', bc:'var(--radar-orange)', desc:'Mesure d\'audience anonyme. Aucune donnée personnelle identifiable n\'est transmise à des tiers. Vous pouvez refuser ou retirer votre consentement à tout moment.' },
            ].map(row => (
              <div key={row.name} style={{ padding:'14px 16px', background:'#fff', borderRadius:8, border:'1px solid rgba(140,106,90,.15)' }}>
                <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:6, flexWrap:'wrap', gap:8 }}>
                  <span style={{ fontWeight:700, fontSize:14 }}>{row.name}</span>
                  <span style={{ padding:'3px 9px', borderRadius:3, fontSize:10, fontFamily:'var(--font-mono)', background:`${row.bc}18`, color:row.bc }}>{row.badge}</span>
                </div>
                <p style={{ fontSize:13, color:'#5A4A3C', lineHeight:1.55 }}>{row.desc}</p>
              </div>
            ))}
          </div>

          {/* Live preferences widget */}
          <div style={{ marginTop:16, padding:'16px 20px', background:'var(--radar-cream)', borderRadius:8, border:'1px solid rgba(217,79,0,.15)' }}>
            <p style={{ fontFamily:'var(--font-mono)', fontSize:11, color:'var(--radar-mid)', textTransform:'uppercase', letterSpacing:'.08em', marginBottom:10 }}>Vos préférences</p>
            {consent ? (
              <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:10 }}>
                <p style={{ fontSize:13 }}>
                  Essentiels : <strong style={{ color:'#2E7D32' }}>✓ Actifs</strong>
                  {' · '}
                  Analytiques : <strong style={{ color: consent.analytics ? '#2E7D32' : '#C62828' }}>
                    {consent.analytics ? '✓ Acceptés' : '✗ Refusés'}
                  </strong>
                  <span style={{ fontSize:11, color:'var(--radar-mid)', marginLeft:8 }}>
                    ({new Date(consent.ts).toLocaleDateString('fr-FR')})
                  </span>
                </p>
                <button onClick={() => { reset(); setDone(true); setTimeout(() => setDone(false), 3000); }}
                  style={{ padding:'7px 14px', background:'none', border:'1px solid rgba(140,106,90,.3)', borderRadius:4, fontFamily:'var(--font-mono)', fontSize:10, cursor:'pointer', color:'var(--radar-mid)', textTransform:'uppercase', letterSpacing:'.04em' }}>
                  {done ? '✓ Réinitialisé' : 'Modifier mes choix'}
                </button>
              </div>
            ) : (
              <p style={{ fontSize:13, color:'var(--radar-mid)' }}>Aucun choix enregistré. La bannière s'affichera à votre prochaine visite.</p>
            )}
          </div>
        </S>

        <S title="4. Vos droits RGPD">
          <p style={{ marginBottom:14 }}>Conformément au RGPD (art. 15 à 22), vous disposez des droits suivants :</p>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(min(220px, 100%), 1fr))', gap:12 }}>
            {[
              ['👁️','Accès','Obtenir une copie de toutes vos données.'],
              ['✏️','Rectification','Corriger des données inexactes ou incomplètes.'],
              ['🗑️','Effacement','Demander la suppression (droit à l\'oubli).'],
              ['🔒','Limitation','Suspendre le traitement de vos données.'],
              ['📦','Portabilité','Recevoir vos données dans un format lisible.'],
              ['🚫','Opposition','Vous opposer à un traitement par intérêt légitime.'],
            ].map(([icon, title, desc]) => (
              <div key={title} style={{ padding:'13px', background:'#fff', borderRadius:8, border:'1px solid rgba(140,106,90,.12)' }}>
                <div style={{ fontSize:20, marginBottom:7 }}>{icon}</div>
                <p style={{ fontWeight:700, fontSize:13, marginBottom:4 }}>{title}</p>
                <p style={{ fontSize:12, color:'#5A4A3C', lineHeight:1.5 }}>{desc}</p>
              </div>
            ))}
          </div>
          <p style={{ marginTop:14 }}>
            Pour exercer vos droits : <a href="mailto:dpo@radar-course.fr" style={{ color:'var(--radar-orange)' }}>dpo@radar-course.fr</a> (réponse sous 1 mois). Vous pouvez aussi saisir la <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer" style={{ color:'var(--radar-orange)' }}>CNIL</a>.
          </p>
        </S>

        <S title="5. Sécurité">
          <div style={{ display:'flex', flexDirection:'column', gap:8 }}>
            {[
              'Chiffrement HTTPS/TLS sur toutes les communications',
              'Mots de passe hachés avec bcrypt (≥ 12 rounds)',
              'Tokens JWT à durée limitée (7 jours)',
              'Contrôle d\'accès par rôle (admin / organisateur / public)',
              'Hébergement en Union Européenne (Gandi, France)',
              'Journaux d\'accès conservés 90 jours puis supprimés automatiquement',
              'Sauvegardes régulières de la base de données',
            ].map(item => (
              <div key={item} style={{ display:'flex', gap:10, alignItems:'flex-start' }}>
                <span style={{ color:'#2E7D32', fontWeight:700, flexShrink:0 }}>✓</span>
                <span style={{ fontSize:14 }}>{item}</span>
              </div>
            ))}
          </div>
        </S>

        <S title="6. Hébergement et transferts de données">
          <p>Vos données sont hébergées <strong>exclusivement en Union Européenne</strong> :</p>
          <ul style={{ paddingLeft:20, marginTop:8 }}>
            <li style={{ marginBottom:6 }}><strong>Serveur applicatif :</strong> Gandi VPS (Paris, France)</li>
            <li style={{ marginBottom:6 }}><strong>Base de données :</strong> MongoDB Atlas (région Europe — Irlande ou France)</li>
            <li style={{ marginBottom:6 }}><strong>Fichiers :</strong> Stockage local sur le serveur Gandi</li>
          </ul>
          <p style={{ marginTop:10 }}>Aucun transfert de données hors UE sans garanties appropriées.</p>
        </S>

        <S title="7. Durées de conservation">
          <ul style={{ paddingLeft:20 }}>
            <li style={{ marginBottom:6 }}>Comptes inactifs depuis plus de <strong>3 ans</strong> : suppression automatique</li>
            <li style={{ marginBottom:6 }}>Inscriptions de course : <strong>1 an</strong> après la course</li>
            <li style={{ marginBottom:6 }}>Classements et résultats : <strong>3 ans</strong> (intérêt sportif)</li>
            <li style={{ marginBottom:6 }}>Logs serveur : <strong>90 jours</strong></li>
            <li style={{ marginBottom:6 }}>Médias galerie : jusqu'à demande de suppression par l'organisateur</li>
          </ul>
        </S>

        <section>
          <h2 style={{ fontSize:'clamp(16px,2.5vw,20px)', fontWeight:700, marginBottom:14 }}>8. Contact</h2>
          <div style={{ padding:'20px 24px', background:'#fff', borderRadius:10, border:'1px solid rgba(217,79,0,.15)' }}>
            <p style={{ fontSize:15, lineHeight:1.8 }}>
              📧 <a href="mailto:dpo@radar-course.fr" style={{ color:'var(--radar-deep)', fontWeight:600 }}>dpo@radar-course.fr</a><br/>
              📮 RÉSAM — [Adresse postale complète] — France
            </p>
          </div>
        </section>

        <p style={{ marginTop:40, fontSize:12, color:'var(--radar-mid)', fontFamily:'var(--font-mono)' }}>
          Dernière mise à jour : {new Date().toLocaleDateString('fr-FR',{day:'numeric',month:'long',year:'numeric'})}
        </p>
      </div>
    </div>
  );
}
